import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import updateLocale from 'dayjs/plugin/updateLocale';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import localizedFormat from 'dayjs/plugin/localizedFormat';

import 'dayjs/locale/pt-br';
import 'dayjs/locale/es';

dayjs.extend(relativeTime);
dayjs.extend(updateLocale);
dayjs.extend(customParseFormat);
dayjs.extend(localizedFormat);

const DAYJS_LOCALE_MAP = {
  pt: 'pt-br',
  en: 'en',
  es: 'es',
};

export const setDayjsLocale = (lang) => {
  const normalized = (lang || 'en').toString().slice(0, 2).toLowerCase();
  dayjs.locale(DAYJS_LOCALE_MAP[normalized] || 'en');
};

dayjs.updateLocale('en', {
  relativeTime: {
    future: 'in %s',
    past: '%s ago',
    s: 'a few seconds',
    m: '1m',
    mm: '%dm',
    h: '1h',
    hh: '%dh',
    d: '1d',
    dd: '%dd',
    M: '1mo',
    MM: '%dmo',
    y: '1y',
    yy: '%dy',
  },
});

export default dayjs;
